import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import ErrorBoundary from '@/components/common/ErrorBoundary';

import App from './App';
import './styles/globals.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element #root not found in the document.');
}

createRoot(rootElement).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
